import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectUserMarket } from '../../../selectors';

interface Params {
    topMarketId: string;
}

function useUserMarket(params: Params) {
    const selectProps = useMemo(() => selectUserMarket, []);

    return useSelector(state => selectProps(state, params));
}

export default useUserMarket;
